<ngx-skeleton-loader [count]="count()" [theme]="{'height': height() + 'px', 'border-radius': '16px', 'background-color': 'var(--color-background-alt)' }"/>
